import {useEffect, useState} from "react"
import {useAppSelector} from "../../../../app/hooks"
import {useCurrency} from "../../../../app/store/store"
import SideNavWidget from "../../../../component/sidenavbar/widget/SideNavWidget"
import fetchWithRetry from "../../../../util/request"
import {fixMojibake} from "../../../../util/encoding"
import Currency, {formatCurrency} from "../../currency/Currency"
import Button from "../../../../component/button/Button"
import GoalContributionModal from "./GoalContributionModal"
import "./GoalWidget.css"
import {useTranslation} from "react-i18next"
import {IconCircleCheck} from "@tabler/icons-react"

interface Goal {
    name: string
    target: number
    received: number
}

export default function GoalWidget(props: {
    currencies: { [key: string]: Currency }
}) {
    const {currencies} = props;
    const {t, i18n} = useTranslation();

    const currencyName = useAppSelector(useCurrency)
    const [data, setData] = useState<Goal | null>();
    const [contributing, setContributing] = useState(false);

    useEffect(() => {
        return fetchWithRetry(async res => {
            if (res.status === 204) return true;
            if (!res.ok) return false;
            let body = (await res.json()) as Goal;
            setData({...body, name: fixMojibake(body.name)});
            return true;
        }, process.env.REACT_APP_API_BASE + "/store/goal");
    }, [i18n.language])

    if (!data) return null;

    const currency = currencies[currencyName];

    const conv = (gems: number) => Math.round(gems * currency.multiplied / currency.gem_value);

    const progress = data.target > 0 ? Math.min(100, data.received / data.target * 100) : 0;
    const completed = data.target > 0 && data.received >= data.target;

    return <SideNavWidget title={data.name} className={completed ? "completed" : undefined}>
        <div className={`store-goal${completed ? " completed" : ""}`}>
            <div className={"progress-track"}>
                <div className={"progress-fill"} style={{width: `${progress}%`}}/>
            </div>
            <p className={"amounts"}>
                <span className={"received"}>{formatCurrency(currency, conv(data.received))}</span>
                {" / "}
                <span className={"target"}>{formatCurrency(currency, conv(data.target))}</span>
            </p>
            {completed ? <p className={"completed-badge"}><IconCircleCheck/> {t("goal.completed")}</p> : null}
            <div className="btn-container">
                <Button onClick={() => {
                    setContributing(true);
                }}>{t(completed ? "goal.contributeMore" : "goal.contribute")}</Button>
            </div>
        </div>
        {contributing ? <GoalContributionModal currencies={currencies} close={() => setContributing(false)}/> : null}
    </SideNavWidget>
}
